module.exports = __webpack_public_path__ + "static/media/img_feature_photo1.e65f2808.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_feature_photo1.webp
// module id = 792
// module chunks = 0